/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/diamond_medium'
export default icon
